var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWindowsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 2.566l6.147-.847v5.94H.5V2.565zm0 10.868l6.147.848V8.415H.5v5.02zm6.823.938L15.5 15.5V8.415H7.323v5.957zm0-12.744v6.03H15.5V.5L7.323 1.628z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/svg/windows-icon.svg";
export { SvgWindowsIcon as ReactComponent };